import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';

const clientAxios: AxiosInstance = axios.create({
  baseURL: `https://api.woodaebbang.com`,
  headers: {
    'Content-Type': 'applicaiton/json',
  },
  withCredentials: true,
});

clientAxios.interceptors.request.use(
  (request) => {
    // console.log('===axios request ===', request);
    return request;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

clientAxios.interceptors.response.use(
  (response) => {
    // console.log('===axios response ===', response);

    return response;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

export async function get<T>(url: string, config?: AxiosRequestConfig) {
  return clientAxios.get<T>(url, config);
}

export async function post<T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig,
) {
  return clientAxios.post<T>(url, data, config);
}

export async function put<T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig,
) {
  return clientAxios.put<T>(url, data, config);
}

export async function patch<T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig,
) {
  return clientAxios.patch<T>(url, data, config);
}

export async function del<T>(url: string, config?: AxiosRequestConfig) {
  return clientAxios.delete<T>(url, config);
}

export interface CommonResponse<T> {
  code: number;
  record: number;
  data: T;
  statusCode: number;
  message: string;
}

export default clientAxios;
